import { Component } from 'react'
import moment from 'moment'
import { Button, Tip } from '@vzmi/shp_shared_compo'
import { YESTERDAY, DEFAULT_DASHBOARD_DATE_RANGE } from '../../../constants/date'
import { getUIFormatDate, DATE_FORMAT } from '../../../lib/MomentHelper'
import DateHelper from '../../../lib/DateHelper'
import { RangePickerField } from '../../Common/Form'
import FormRow from '../../Common/NewDashboard/FormRow/FormRow'
import {
  formDecorator,
  Field
} from '../../Common/forms'
import styles from './BrandAnalysisSearchForm.css'

export const FIELD = {
  MAIN_RANGE: 'mainRange'
}

export const INIT_VALUES = {
  [FIELD.MAIN_RANGE]: DEFAULT_DASHBOARD_DATE_RANGE
}

export const CONFIG = {
  form: 'BRAND_ANALYSIS_DASHBOARD_FORM',
  initialValues: INIT_VALUES
}

class BrandAnalysisSearchForm extends Component {
  constructor (props) {
    super(props)
    /*
          資料查詢區塊
          僅接30天內之資料查詢
          起：兩年以前之日期不可選擇
          迄且現在是 12:00:00 以後：今天(含)以後之日期不可選擇
          迄且現在是 11:59:59 以前：前一天(含)以後之日期不可選擇
        */
    const {
      startMinDate
    } = DateHelper.getSaleStatDefaultPeriod()
    const [start, end] = DEFAULT_DASHBOARD_DATE_RANGE
    this.state = {
      periodStartMinDate: startMinDate,
      periodEndMaxDate: YESTERDAY,
      periodStart: getUIFormatDate(start),
      periodEnd: getUIFormatDate(end)
    }
  }

  componentDidMount () {
    this.props.onFormInit(this.props)
  }

  onSubmit = (e) => {
    this.props.handleSubmit(e)
  }

  // 調整「起」的日期後，則「迄」跟著自動變動：
  // 「起」＋ㄧ個月 (31 天) ; 之後的日期 disable 不可選
  // 若「起」＋ㄧ個月 (31 天)  > 昨日，則為昨日
  disabledDate = dateMoment => {
    const {
      periodEndMaxDate,
      periodStartMinDate,
      periodStart
    } = this.state
    const oneMonthsLaterData = moment(periodStart).add(31, 'days')
    const todayData = moment()
    return dateMoment < moment(periodStartMinDate) ||
            dateMoment >= (moment(oneMonthsLaterData).isBefore(todayData) ? oneMonthsLaterData : moment(periodEndMaxDate, DATE_FORMAT.UI))
  }

  onCalendarChange = dateMoment => {
    const periodStart = getUIFormatDate(dateMoment[0])
    this.setState({
      periodStart
    })
  }

  onMainRangeChange = (dateMoment, dateString) => {
    const [periodStart, periodEnd] = dateString
    this.setState({
      periodStart,
      periodEnd
    })
  }

  render () {
    const { customRange } = this.props
    return (
      <form
        onSubmit={this.onSubmit}
        className={styles.searchForm}
      >
        <FormRow
          label='日期區間'
          labelAlign='center'
        >
          <Field
            key={FIELD.MAIN_RANGE}
            name={FIELD.MAIN_RANGE}
            data-role={FIELD.MAIN_RANGE}
            className={styles.rangePicker}
            component={RangePickerField}
            defaultValue={customRange}
            onChange={this.onMainRangeChange}
            disabledDate={this.disabledDate}
            onCalendarChange={this.onCalendarChange}
          />
        </FormRow>
        <FormRow
          labelAlign='top'
          className={styles.tips}
        >
          <Tip type='info'>
            可查詢最早日期為兩年前，起迄區間最長為一個月，每日中午更新
          </Tip>
        </FormRow>
        <FormRow labelAlign='top'>
          <Button
            type='submit'
            data-role='search-btn'
            size='large'
            className={styles.searchBtn}
          >
            查詢
          </Button>
        </FormRow>
      </form>
    )
  }
}

const SearchFormWithDecorator = formDecorator(CONFIG)(BrandAnalysisSearchForm)

export default SearchFormWithDecorator
